import { useGetAdminInvoiceReportSummarySuspense } from 'ap-openapi';

export type PayeeContactOfficeMember = {
  id: string;
};

/**
 * Backs the "add payee's in-house contacts" one-click action for the admin
 * ShareDrawer. Mirrors invoice_reports' `useInvoiceReportPayeeContacts`: the
 * admin report_summary's `payee` (serialized via `ApPayeeDetailResource`,
 * same as the applicant-facing endpoint) already carries its
 * `contact_office_members` inline, so no separate per-payee round trip or
 * admin-specific backend endpoint is needed.
 */
export const useAdminInvoiceReportPayeeContacts = (
  reportId: string
): PayeeContactOfficeMember[] => {
  const { data, error } = useGetAdminInvoiceReportSummarySuspense(reportId);
  if (error) throw error;

  return (data.data?.payee?.contact_office_members ?? [])
    .filter((contact): contact is { id: string } => !!contact.id)
    .map((contact) => ({ id: contact.id }));
};
